/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/jsx-curly-newline */
import React, {
  Dispatch,
  SetStateAction,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  InputLabel,
  Button as MaterialButton,
  Box,
  Alert,
  AlertTitle,
} from '@material-ui/core';
import { makeStyles } from '@mui/styles';
import { Produto } from '../../../../pages/Cadastros/Produtos';
import Input from '../../../Input';
import { Adicional } from './style';
import { BaixaAdicionais } from '..';
import api from '../../../../services/api';
import { useToast } from '../../../../hooks/toast';
import { CdProdPaiContext } from '../../../../contexts/CdProdPaiContext';
import { MontagemContext } from '../../../../contexts/MontagemContext';
import { Montagem } from '../../DialogInsumos';

interface Dialog {
  listaProdutos: Produto[];
  open: boolean;
  setOpenInsertBaixaAdicionais: Dispatch<SetStateAction<boolean>>;
  cdBaixaAdicional: string;
  populaTabela: () => void;
  setCdBaixaAdicional: Dispatch<SetStateAction<string>>;
  typeRequest: string;
}
interface Request {
  cd: number;
}
const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    backgroundColor: '#FFF',
    height: '60vh',
  },
});
const DialogAdicionais = ({
  listaProdutos,
  open,
  setOpenInsertBaixaAdicionais,
  cdBaixaAdicional,
  setCdBaixaAdicional,
  populaTabela,
  typeRequest,
}: Dialog) => {
  const [openCadastro, setOpenCadastro] = useState(false);
  const [cdAtual, setCdAtual] = useState('');
  const [close, setClose] = useState('');
  const [baixaAdicionais, setBaixaAdicionais] = useState<BaixaAdicionais>({
    cd: '',
    cd_prod: '',
    cd_prod_pai: '',
    nm: '',
    qtd: '',
    preco_custo: '',
    vl: '',
    tipo: '',
    ordem: '',
    qtd_min: '',
    qtd_max: '',
    qtd_inicial: '',
  });
  const classes = useStyles();
  const { addToast } = useToast();
  const { cd_prod_pai } = useContext(CdProdPaiContext);
  const {
    montagens,
    setCurrentCd,
    addMontagem,
    setAddMontagem,
    setMontagens,
  } = useContext(MontagemContext);

  const handleCloseInsertBaixaAdicionais = useCallback(
    (closePost = true) => {
      // getMontagem(cd_prod_pai);
      if (addMontagem && !closePost) {
        setMontagens(
          montagens
            .filter((mont, index) => montagens.length != index + 1)
            .map((mont, index) => {
              if (montagens.length == index + 2) {
                mont.focus = true;
              }
              return mont;
            }),
        );
      }
      setAddMontagem(false);
      setOpenInsertBaixaAdicionais(false);
    },
    [
      addMontagem,
      montagens,
      setAddMontagem,
      setMontagens,
      setOpenInsertBaixaAdicionais,
    ],
  );

  const handleOpenCadastro = useCallback(({ cd }: Produto) => {
    setBaixaAdicionais({ cd_prod: cd } as BaixaAdicionais);
    setOpenCadastro(true);
  }, []);

  const handleCloseCadastro = useCallback(() => {
    setOpenCadastro(false);
  }, []);
  const getBaixaAdicional = useCallback(
    async (cd) => {
      await api
        .get<BaixaAdicionais[]>(`baixa_adicionais/baixa_adicional/${cd}`)
        .then((response) => {
          setBaixaAdicionais(response.data[0]);
          setOpenCadastro(true);
        })
        .catch((error) => {
          addToast({
            type: 'error',
            title: 'Erro',
            description: `Ops, ocorreu algum erro ao listar o produto: ${error}`,
          });
        });
    },
    [addToast],
  );

  const handleSubmitCadastro = useCallback(async () => {
    const cd_montagem = montagens.filter((montagem) => montagem.focus);
    if (cd_montagem[0].cd == null) {
      const response = await api.post<Request>('montagem', {
        nm: cd_montagem[0].nm,
        ordem: cd_montagem[0].ordem,
      });
      montagens.map((montagem) => {
        if (montagem.focus) {
          montagem.cd = response.data.cd;
        }
        return montagem;
      });
    }

    const mont: Montagem[] = montagens.filter((montagem) => montagem.focus);
    if (typeRequest == 'create') {
      const response = await api.post('baixa_adicionais', {
        ...baixaAdicionais,
        cd_montagem: mont[0].cd,
        cd_prod_pai,
      });
      populaTabela();
      if (response.status === 200) {
        setCurrentCd(mont[0].cd);
        // getMontagem(cd_prod_pai);
        setClose('created');
        handleCloseCadastro();
        handleCloseInsertBaixaAdicionais(true);
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: `O adicional foi cadastrado com sucesso.`,
        });
      }
    } else {
      const response = await api.put('baixa_adicionais', {
        ...baixaAdicionais,
        cd_prod_pai,
        cd: cdAtual,
      });
      populaTabela();
      if (response.status === 200) {
        setCurrentCd(mont[0].cd);
        // getMontagem(cd_prod_pai);
        handleCloseCadastro();
        handleCloseInsertBaixaAdicionais(true);
        addToast({
          type: 'success',
          title: 'Sucesso',
          description: `O adicional foi cadastrado com sucesso.`,
        });
      }
    }
  }, [
    addToast,
    baixaAdicionais,
    cdAtual,
    cd_prod_pai,
    handleCloseCadastro,
    handleCloseInsertBaixaAdicionais,
    montagens,
    populaTabela,
    setCurrentCd,
    typeRequest,
  ]);
  /*   useEffect(() => {
    async function getMontagens() {
      if (montagens.length > 0 && addMontagem) {
        const cd_montagem = montagens.filter((montagem) => montagem.focus);
        if (cd_montagem[0].cd == null) {
          const response = await api.post<Request>('montagem', {
            nm: cd_montagem[0].nm,
          });
          montagens.map((montagem) => {
            if (montagem.focus) {
              montagem.cd = response.data.cd;
            }
            return montagem;
          });
        }
        setAddMontagem(false);
      }
    }
    getMontagens();
  }, [addMontagem, montagens, setAddMontagem]); */

  useEffect(() => {
    if (cdBaixaAdicional != '') {
      getBaixaAdicional(cdBaixaAdicional);
      setCdAtual(cdBaixaAdicional);
      setCdBaixaAdicional('');
    }
  }, [cdBaixaAdicional, getBaixaAdicional, setCdBaixaAdicional]);
  return (
    <>
      <Dialog
        open={open}
        onClose={() => handleCloseInsertBaixaAdicionais(false)}
        fullWidth
        maxWidth="xs"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Adicionais
          <Alert severity="info">
            Ao criar uma montagem é obrigatório cadastrar um insumo.
          </Alert>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <ul className={classes.root}>
              {listaProdutos &&
                listaProdutos.map((produto: Produto) => (
                  <Adicional
                    key={produto.cd}
                    onClick={() => handleOpenCadastro(produto)}
                  >
                    <div>{produto.cd}</div>
                    <div>{produto.nm}</div>
                    <div>{produto.vl}</div>
                  </Adicional>
                ))}
            </ul>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openCadastro}
        onClose={handleCloseCadastro}
        fullWidth
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Adicionais</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.root}
          >
            <Box flexWrap="wrap" component="div">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',

                  flex: 1,
                  flexWrap: 'wrap',
                }}
              >
                <div style={{ alignSelf: 'flex-start', padding: '8px' }}>
                  <InputLabel
                    id="select-label"
                    style={{ marginBottom: '4px', marginLeft: '2px' }}
                  >
                    Quantidade
                  </InputLabel>
                  <Input
                    style={{ width: '150px' }}
                    name="preco_custo"
                    placeholder="Quantidade"
                    defaultValue={baixaAdicionais.qtd}
                    onChange={(e) =>
                      setBaixaAdicionais({
                        ...baixaAdicionais,
                        qtd: e.target.value,
                      })
                    }
                  />
                </div>
                <div style={{ alignSelf: 'flex-start', padding: '8px' }}>
                  <InputLabel
                    id="select-label"
                    style={{ marginBottom: '4px', marginLeft: '2px' }}
                  >
                    Ordem
                  </InputLabel>
                  <Input
                    style={{ width: '150px' }}
                    name="preco_custo"
                    placeholder="Ordem"
                    defaultValue={baixaAdicionais.ordem}
                    onChange={(e) =>
                      setBaixaAdicionais({
                        ...baixaAdicionais,
                        ordem: e.target.value,
                      })
                    }
                  />
                </div>
                <div style={{ alignSelf: 'flex-start', padding: '8px' }}>
                  <InputLabel
                    id="select-label"
                    style={{ marginBottom: '4px', marginLeft: '2px' }}
                  >
                    Qtd Mínima
                  </InputLabel>
                  <Input
                    style={{ width: '150px' }}
                    name="preco_custo"
                    placeholder="Qtd Mínimo"
                    defaultValue={baixaAdicionais.qtd_min}
                    onChange={(e) =>
                      setBaixaAdicionais({
                        ...baixaAdicionais,
                        qtd_min: e.target.value,
                      })
                    }
                  />
                </div>
                <div style={{ alignSelf: 'flex-start', padding: '8px' }}>
                  <InputLabel
                    id="select-label"
                    style={{ marginBottom: '4px', marginLeft: '2px' }}
                  >
                    Qtd Máxima
                  </InputLabel>
                  <Input
                    style={{ width: '150px' }}
                    name="preco_custo"
                    placeholder="Qtd Máxima"
                    defaultValue={baixaAdicionais.qtd_max}
                    onChange={(e) =>
                      setBaixaAdicionais({
                        ...baixaAdicionais,
                        qtd_max: e.target.value,
                      })
                    }
                  />
                </div>
                <div style={{ alignSelf: 'flex-start', padding: '8px' }}>
                  <InputLabel
                    id="select-label"
                    style={{ marginBottom: '4px', marginLeft: '2px' }}
                  >
                    Qtd Inicial
                  </InputLabel>
                  <Input
                    style={{ width: '150px' }}
                    name="preco_custo"
                    placeholder="Qtd Inicial"
                    defaultValue={baixaAdicionais.qtd_inicial}
                    onChange={(e) =>
                      setBaixaAdicionais({
                        ...baixaAdicionais,
                        qtd_inicial: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MaterialButton
            onClick={handleCloseCadastro}
            style={{
              color: '#2c73e9',
            }}
          >
            CANCELAR
          </MaterialButton>
          <MaterialButton
            onClick={handleSubmitCadastro}
            style={{
              color: '#2c73e9',
            }}
          >
            CADASTRAR
          </MaterialButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DialogAdicionais;
